import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

// Keeps workspace ID in sync with organization name until the user edits the
// workspace field directly (clearing it re-enables sync). All normalization
// logic lives on the backend; this controller only requests previews and applies
// Turbo Stream responses.
class OrganizationSetupController extends Controller {
  static targets = ["name", "schema"];

  connect() {
    this.workspaceTouched = this.schemaTarget.value.length > 0;
    this.previewTimer = null;
  }

  nameInput() {
    if (this.workspaceTouched) return;

    this.requestPreview(this.nameTarget.value);
  }

  workspaceInput() {
    const raw = this.schemaTarget.value;
    if (raw === "") {
      this.workspaceTouched = false;
      return;
    }

    this.workspaceTouched = true;
    this.requestPreview(raw);
  }

  requestPreview(raw) {
    if (this.previewTimer) globalThis.clearTimeout(this.previewTimer);

    this.previewTimer = globalThis.setTimeout(async () => {
      const url = "/organizations/schema_name_preview";
      const body = new URLSearchParams({ raw: raw || "" }).toString();

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          "X-CSRF-Token": this.csrfToken(),
        },
        body,
        credentials: "same-origin",
      });

      if (!response.ok) return;
      const stream = await response.text();
      Turbo.renderStreamMessage(stream);
    }, 150);
  }

  csrfToken() {
    const el = document.querySelector("meta[name='csrf-token']");
    return el ? el.getAttribute("content") : "";
  }
}

export default OrganizationSetupController;
